import { cn } from '@/lib/utils'
import { zodResolver } from '@hookform/resolvers/zod'
import { Paper, Typography } from '@mui/material'
import logo from 'assets/logo.svg'
import textoLogo from 'assets/ponto-agil-texto.svg'
import { useAuth } from 'hooks'
import { FormProvider, useForm } from 'react-hook-form'
import { Outlet } from 'react-router-dom'
import { LoginSchema, planos as planosApi, Login as TLogin } from 'service/api'
import { LoginForm } from 'templates/Auth'
import { ToggleTheme } from '../global/components/ToggleTheme'

export function Login() {
    const { data: planos } = planosApi.useFetch({
        enabled: window.location.pathname !== '/',
        refetchOnWindowFocus: false,
    })
    const methods = useForm<TLogin>({
        resolver: zodResolver(LoginSchema),
    })
    const { handleLogin } = useAuth()

    return (
        <div className="h-[calc(100vh-4rem)] flex flex-col w-full overflow-clip">
            <div className="ml-auto flex flex-end p-4">
                <ToggleTheme />
            </div>
            <div className="flex flex-col my-auto gap-2 items-center">
                <div
                    className={cn(
                        'flex items-center justify-center gap-4 mb-4 w-96',
                        'dark:invert',
                    )}
                >
                    <div className="size-16 aspect-1/1">
                        <img
                            src={logo}
                            alt="logo"
                            loading="lazy"
                            className="size-full filter-[invert(11%)_sepia(42%)_saturate(2894%)_hue-rotate(213deg)_brightness(95%)_contrast(97%)] dark:filter-none"
                        />
                    </div>
                    <div className="h-16 w-auto">
                        <img
                            src={textoLogo}
                            alt="PONTO ÁGIL"
                            loading="lazy"
                            className="size-full filter-[invert(11%)_sepia(42%)_saturate(2894%)_hue-rotate(213deg)_brightness(95%)_contrast(97%)] dark:filter-none"
                        />
                    </div>
                </div>
                <div className="flex-1">
                    <Paper
                        sx={{
                            padding: '1rem 1.2rem 1.2rem 1.2rem',
                            maxWidth: '25rem',
                            marginX: 'auto',
                            borderRadius: '1rem',
                            display: 'flex',
                            flexDirection: 'column',
                        }}
                    >
                        <FormProvider {...methods}>
                            <Typography
                                variant="button"
                                color="primary"
                                sx={{
                                    fontSize: 22,
                                    textAlign: 'center',
                                    marginBottom: '0.8rem',
                                }}
                            >
                                Bem vindo
                            </Typography>
                            <form onSubmit={methods.handleSubmit(handleLogin)}>
                                <LoginForm />
                            </form>
                        </FormProvider>
                    </Paper>
                </div>
            </div>
            <Outlet context={{ planos }} />
        </div>
    )
}
